import { useState, useEffect } from "react";
import "./Header.css";
import AvatarMenu from "../avatar-menu/AvatarMenu";
import { useDispatch, useSelector } from "react-redux";
import { selectUIStates, selectUser, setUIStates } from "../../redux/features/appData";
import { MediaManager } from "../media-manager/MediaManager";

export const Header = () => {

    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates);
    const dispatch = useDispatch();
    
    return (
        <>
            <div className="header-items">
                <div className="header-menu">
                    <AvatarMenu image={storeUser?.avatarURL || ""} />
                </div>
            </div>

            {uiStates.mediaManagerOpen &&
                <MediaManager 
                    isOpen={uiStates.mediaManagerOpen}
                    noSelect={true}
                    onClose={() => dispatch(setUIStates({...uiStates, mediaManagerOpen: false}))}
                    onSelectedAsset={()=>{}}
                />
            }
        </>
    )
}